module.exports = __webpack_public_path__ + "img/ico_help_tooltip.270a452c.svg";